import React, { useEffect, useState } from "react";
import MuiSideFilter from "../Pages/Grid/Components/MuiSideFilter";
import { useDispatch, useSelector } from "react-redux";
import { setShowAppListOfUpdates } from "../reduxStore/SettingsReducer";
import { Autocomplete, Box, Button, CircularProgress, IconButton, TextField, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Background } from "devextreme-react/range-selector";
import CloseIcon from "@mui/icons-material/Close";
import CardItem from "./Components/CardItem";
import Cookies from 'universal-cookie'
import host from "../assets/js/Host";
import axios from "axios";
import { toast } from "react-toastify";
import * as RiIcons from 'react-icons/ri'

const cookies = new Cookies();
export default function AppListOfUpdates() {
  const [t] = useTranslation("common");
  const dispatch = useDispatch();
  const showAppListOfUpdates = useSelector(
    (state) => state.settingsData.showAppListOfUpdates
  );
  const APPVERSIONUPDATES = useSelector(
    (state) => state.translateData.translation_ar
  );
  const gridDirection = useSelector((state) => state.settingsData.gridDirection);
  const [loading, setLoading] = useState(false)
  const [errorLoadingData, setErrorLoadingData] = useState(false)
  const [data, setData] = useState([])
  const [selectedVersion, setSelectedVersion] = useState({
    version: require('../../package.json').version
  })
  const [versions, setVersions] = useState([])
  const getColors = (direction) => {
    let darkcolorActive = "#1e6a99";
    let lightcolorActive = "#1e6a99a0";
    let darkcolorNone = "#a7a2a2";
    let lightcolorNone = "#b9b9b9";

    if (gridDirection == direction) {
      return { dark: darkcolorActive, light: lightcolorActive };
    } else {
      return { dark: darkcolorNone, light: lightcolorNone };
    }
  };
  const getData = (pageSize_, pageNumber_) => {
    const jwt = cookies.get("token");

    var headers = {
      jwt: jwt,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    };
    setLoading(true);
    setErrorLoadingData(false)
    const searchFields = {
      version: selectedVersion&&selectedVersion?.version?selectedVersion?.version:require('../../package.json').version,
    }
    axios({
      url: host + `update_contents/list?params={"searchFields":${JSON.stringify(searchFields)}}`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        setTimeout(() => {
          setLoading(false);

        }, 3000)
        if (res?.status && res?.data?.status) {
          setData(res?.data?.data)
        } else {
          setErrorLoadingData(true)
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        setLoading(false);
      });
  };
  const getDataOfVersiosn = () => {
    const jwt = cookies.get("token");
    var headers = {
      jwt: jwt,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    };
    setLoading(true);
    axios({
      url: host + `update_contents/list_of_versions`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        setTimeout(() => {
          setLoading(false);

        }, 3000)
        if (res?.status && res?.data?.status) {
          setVersions(res?.data?.data)
        } else {
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        setLoading(false);
      });
  };
  useEffect(() => {
    if (showAppListOfUpdates) {
      getDataOfVersiosn()
      getData()
    }
  }, [showAppListOfUpdates])
  useEffect(()=>{
    if(selectedVersion)
    getData()
  },[selectedVersion])
  const renderContent = () => {
    if (!loading && !errorLoadingData && data?.length > 0) {
      return data?.map(item => (<CardItem key={item?.id} {...item} />))
    } else if (!loading && errorLoadingData) {
      return <Box
        style={{
          width: '100%',
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <img
          src={require('../assets/img/no-content.png')}
          style={{
            width: '150px',
            height: '150px',
          }}
        />
        <span>Failed Loading Data or there is no Internet.</span>
        <Button sx={{ backgroundColor: '#1e6a99', color: '#fff', marginTop: "10px" }} onClick={getData}>Reload</Button>
      </Box>
    } else if (loading) {
      return <Box
        style={{
          width: '100%',
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <CircularProgress sx={{ color: '#1e6a99' }} size={30} />
      </Box>
    } else {
      return <Box
        style={{
          width: '100%',
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <img
          src={require('../assets/img/no-content.png')}
          style={{
            width: '150px',
            height: '150px',
          }}
        />
        <span>No Data!</span>
        <Button sx={{ backgroundColor: '#1e6a99', color: '#fff', marginTop: "10px" }} onClick={getData}>Reload</Button>
      </Box>
    }
  }
  return (
    <MuiSideFilter
      open={showAppListOfUpdates}
      setOpen={(value) => {
        dispatch(setShowAppListOfUpdates(false));
      }}
      width="430px !important"
      backgroundColor="rgba(255, 255, 255, 1)"
      boxShadow="rgba(145, 158, 171, 0.24) -40px 40px 80px -8px"
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "60px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 10px",
            borderBottom: " 2px dotted #d6d6d6",
          }}
        >
          <Box  
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap:'10px'
          }}>
            <span>{APPVERSIONUPDATES?.APPVERSIONUPDATES?.title}</span>
            <Autocomplete
              id="combo-box-demo"
              options={versions ? versions : []}
              value={selectedVersion ? selectedVersion : null}
              onChange={(e, newValue) => {
                setSelectedVersion(newValue)
              }}
              getOptionLabel={((option) => {
                return option?.version
              }) || ''}
              popupIcon={<RiIcons.RiArrowDropDownLine />}
              clearIcon={<CloseIcon sx={{ fontSize: '20px' }} onClick={() => setSelectedVersion({
                version: require('../../package.json').version
              })} />}
              disableClearable
              renderInput={(params) => <TextField sx={{width:'120px'}} {...params} label={'Version'} variant="filled" />}
            />
            {/* <span style={{ color: '#1e6a99', marginLeft: '2px' }}>{require('../../package.json')?.version}</span> */}

          </Box>
          <Tooltip title={APPVERSIONUPDATES?.APPVERSIONUPDATES?.close}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch(setShowAppListOfUpdates(false));
              }}
            >
              <CloseIcon />
            </Box>
          </Tooltip>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            // display: "flex",
            // flexDirection: "column",
            // alignItems: "center",
            // justifyContent: "flex-start",
            // flexWrap:'wrap',
            overflowY: 'scroll',
            overflowX: 'hidden',
            padding: '10px 6px 10px 10px',
            gap: '5px',
            '& .MuiCard-root': {
              width: '99% !important',
            }
          }}
        >
          {renderContent()}
          <br />
          <br />
          <br />

        </Box>
      </Box>
    </MuiSideFilter>
  );
}
